module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ch-no"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _vm._v("6")]), _vm._v(" "), _c('p', {
    staticClass: "ch-title"
  }, [_vm._v("Junior Year")]), _vm._v(" "), _c('p', {
    staticClass: "ch-head"
  }, [_vm._v("1915–1916")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fitzgerald’s junior year, 1915–16, was a disaster. He began the college year by failing the Make-up exam in qualitative analysis, thereby again becoming ineligible for campus offices—and in particular for the presidency of the Triangle Club, which went to Paul Nelson. Twenty years later Fitzgerald analyzed the permanent results of that disappointment:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent-b"
  }, [_vm._v("To me college would never be the same. There were to be no badges of pride, no medals, after all. It seemed on one March afternoon that I had lost every single thing I wanted—and that night was the first time that I hunted down the spectre of womanhood that, for a little while, makes everything else seem unimportant.")]), _vm._v(" "), _c('p', {
    staticClass: "para-b"
  }, [_vm._v("Years later I realized that my failure as a big shot was all right—instead of serving on committees, I took a beating in English poetry; when I got the idea of what it was all about, I set about learning how to write. On Shaw’s principle that “If you don’t get what you like, you better like what you get,” it was a lucky break—at the moment, it was a harsh and bitter business to know that my career as a leader of men was over.")]), _vm._v(" "), _c('p', {
    staticClass: "para-b"
  }, [_vm._v("Since that day I have not been able to fire a bad servant, and I am astonished and impressed by people who can. Some old desire for personal dominance was broken and gone. Life around me was a solemn dream, and I lived on the letters I wrote to a girl in another city. A man does not recover from such jolts—he becomes a different person and, eventually, the new person finds new things to care about."), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-31",
      "id": "pt3_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("31")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("Fitzgerald’s expression for sexual intercourse with a whore—“I hunted down the spectre of womanhood”—is noteworthy. As late as 1936 fornication would still carry connotations of supernatural corruption in his fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That Fitzgerald’s reaction to the deprivation of a college honor was so extreme as to cripple his whole life may seem incredible; but his analysis of the loss provides a gauge of the intensity of his commitment to the prizes of life—not just the prizes of Princeton. For Fitzgerald the prizes of life were"), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _vm._v(" more than badges of position or fame. He measured himself against personal standards of character and will, believing that “life was something you dominated if you were any good.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-32",
      "id": "pt3_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("32")])]), _vm._v(" His Princeton failure provoked another seizure of self-assessment in which he tried to develop new ways to realize his aspirations. If "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This Side of Paradise")]), _vm._v(" can be trusted as autobiography, Father Fay helped him to reach the concept of the “personage,” the man who is known by his achievements. Monsignor Darcy—the Fay figure—counsels Amory Blaine in the novel:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "para-b"
  }, [_vm._v("“A personality is what you thought you were.… Personality is a physical matter almost entirely; it lowers the people it acts on—I’ve seen it vanish in a long sickness. But while a personality is active, it overrides ‘the next thing.’ Now a personage, on the other hand, gathers. He is never thought of apart from what he’s done. He’s a bar on which a thousand things have been hung—glittering things sometimes, as ours are; but he uses those things with a cold mentality back of them.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-33",
      "id": "pt3_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("Fitzgerald would always display a perplexing ability to do “the next thing” and then disregard it. He wanted to be both a personality and a personage, a magnetic individual and an achiever.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the fall of 1915 Fitzgerald roomed alone at 32 Little Hall. He scribbled wake-up notes on the dorm wall, and Dale Warren, a freshman who roomed across the hall, became his alarm clock. Warren remembered that manuscripts were piled all around Fitzgerald’s room. The first term of his junior year Fitzgerald’s courses included English (the Renaissance—Spenser, Marlowe, Sidney), English (Chaucer), Italian (grammar, composition, and reading), French (the Romantic Movement from Rousseau to France), philosophy (history of philosophy), and a sixth course in ancient art for exceeding the fifty-cut limit.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The French literature course was taught by Christian Gauss, the only Princeton professor with whom Fitzgerald maintained a friendship after college. Gauss later observed that at Princeton Fitzgerald reminded him of all of the Karamazov brothers at once."), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-34",
      "id": "pt3_34",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("34")])]), _vm._v(" Fitzgerald acknowledged this mixture of unreconciled qualities in his character in a letter to Wilson: “I dont think you ever realized at Princeton the childlike simplicity that lay behind all my petty sophistication, selfishness and my lack of a real sense of honor.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-35",
      "id": "pt3_35",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("35")])]), _vm._v(" The need for values or codes was much on Fitzgerald’s mind at college, and he told Norris Jackson and Joe McKibbin that he wanted five good principles to live up to.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Although still ineligible to hold office or perform in the Triangle Club show, Fitzgerald became involved in the production of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Evil Eye,")]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _vm._v(" impressing the cast with his ability to write new lyrics on demand during rehearsals. Perhaps as compensation for his ineligibility, the Triangle Club used a publicity photo of Fitzgerald costumed as a showgirl. It appeared in several newspapers, including "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New York Times,")]), _vm._v(" and brought him fan letters from men who wanted to meet him and from an agent who offered to book him for a vaudeville tour as a female impersonator—a popular act at the time. There is no evidence that Fitzgerald especially delighted in dressing as a woman. All the female roles in the Triangle Club shows were played by male undergraduates, which was regarded as part of the fun. It was conventional collegiate humor and elicited no ominous comment.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fitzgerald continued to write steadily for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tiger")]), _vm._v(" in his junior year. In October 1915 there was a competition for a new Princeton football song, which Fitzgerald won with “A Cheer for Princeton”:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-lt"
  }, [_vm._v("Glory, Glory to the Black and Orange,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("It’s the Tiger’s turn to-day.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Glory, glory it’s the same old story")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Soon as Princeton starts to play.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Eli, Eli, all your hopes are dead")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("For the Tiger’s growling in his lair.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Don’t you hear him?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("You’ll learn to fear him,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Try to face him if you dare.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-lt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chorus")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Princeton, cheer for Princeton,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Raise your voices, loud and free")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Strong and steady")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Ever ready")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("For defeat or victory.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Princeton, cheer for Princeton,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Always sure to win renown,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("So we’ll raise our praise to Nassau")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("To the pride of the Tiger town."), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-36",
      "id": "pt3_36",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "para-t"
  }, [_vm._v("“A Cheer for Princeton” seems unique in its genre for anticipating defeat—which may be why it never caught on.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fitzgerald went to the Yale game at New Haven in October, perhaps to hear “A Cheer for Princeton,” and had dinner with Ginevra in Waterbury, Connecticut. His epistolary courtship continued unabated, some of his letters running to thirty pages. He paid less attention than ever to his classes, for the loss of the “badges of pride” made the effort of studying seem worthless. "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _vm._v("His dissipations took the form of conversation, unrequired reading, and writing. He found his English professors lacking in real enthusiasm for literature, as shown by two of the poems he incorporated into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This Side of Paradise:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-lt"
  }, [_vm._v("Good-morning, Fool …")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Three times a week")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("You hold us helpless while you speak,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Teasing our thirsty souls with the")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Sleek “yeas” of your philosophy …")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("…………")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("The hour’s up … and raised from rest")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("One hundred children of the blest")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Cheat you a word or two with feet")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("That down the noisy aisle-ways beat …")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("Forget on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("narrow-minded earth")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("The Mighty Yawn that gave you birth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-r3"
  }, [_vm._v("—“In a Lecture Room”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-37",
      "id": "pt3_37",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "para-t"
  }, [_vm._v("Fitzgerald wrote a four-stanza poem during a class on Tennyson’s “A Song in the Time of Order” and handed it to the teacher, Alfred Noyes:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l3"
  }, [_vm._v("Songs in the time of order")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l"
  }, [_vm._v("You left for us to sing,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l1"
  }, [_vm._v("Proofs with excluded middles,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-l2"
  }, [_vm._v("Answers to life in rhyme …"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-38",
      "id": "pt3_38",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "para-t"
  }, [_vm._v("Fitzgerald was in the infirmary twice in November with what was diagnosed as malaria, but which may have been a mild case of tuberculosis. On 28 November he attended his last class and went home early for Christmas vacation. The Triangle Club’s tour with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Evil Eye")]), _vm._v(" was a great success. In Chicago three hundred girls occupied the front rows; after the final curtain they gave the Princeton locomotive cheer and tossed bouquets at the cast. In St. Paul and Minneapolis the shop windows and trolleys were decorated with Princeton colors; but Fitzgerald was in the audience and not on the stage.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He dropped out of college for the rest of the year to recuperate, a decision dictated by his academic situation. His Princeton transcript notes that “Mr Fitzgerald was required to withdraw from the University January 3, 1916 for scholastic deficiencies”; but in May he persuaded Dean Howard McClennan to provide him with a To-Whom-It-May-Concern letter stating that Fitzgerald had voluntarily withdrawn “because of ill health and that he was fully at liberty, at that time, to go on with his class.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-39",
      "id": "pt3_39",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("39")])]), _vm._v(" The dean sent this letter with a note saying, “This is for your sensitive feelings. I hope you will find it soothing.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-40",
      "id": "pt3_40",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("40")])]), _vm._v(" For the rest of his life Fitzgerald remained touchy"), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _vm._v(" about remarks that he had flunked out of Princeton, insisting that he had left on a stretcher. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ledger")]), _vm._v(" judgment for 1915–16 is: “A year of terrible disappointments + the end of all college dreams. Everything bad in it was my own fault.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In February, Fitzgerald perpetrated a locally famous hoax when, with Gus Schurmeier, he attended a Psi U dance at the University of Minnesota dressed as a girl and shocked his dancing partners with a racy line. (The joke supposedly ended when Fitzgerald tried to use the men’s room.) He spent the spring of 1916 in St. Paul ostensibly studying, but mostly loafing and writing. His book for a Triangle Club show was declined, and he continued to send contributions to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tiger")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lit.")]), _vm._v(" Fitzgerald’s only "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lit")]), _vm._v(" appearance in the spring was “To My Unused Greek Book,” an imitation of Keats’s “Ode on a Grecian Urn.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fitzgerald was never close to his sister Annabel, who did not share his intense self-awareness. Five years younger than he, Annabel did not interest him during his boyhood, and while he was at Newman and Princeton she was at convent schools. When she was a teenager, Fitzgerald turned his attention to refining her social skills: he always wanted to educate or improve the women he knew. He provided detailed written instructions on how to refine her image and make herself more popular with boys.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "li-para"
  }, [_c('span', {
    staticClass: "li-num"
  }, [_vm._v("(C) ")]), _vm._v("I’ll line up your good points against your bad physically.")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border-collapse": "collapse"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "top_left2"
  }, [_c('p', {
    staticClass: "t-para"
  }, [_vm._v("Good")])]), _vm._v(" "), _c('td', {
    staticClass: "top_left2"
  }, [_c('p', {
    staticClass: "t-para"
  }, [_vm._v("Bad")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "top_left"
  }, [_c('p', {
    staticClass: "t-para"
  }, [_vm._v("Hair")])]), _vm._v(" "), _c('td', {
    staticClass: "top_left"
  }, [_c('p', {
    staticClass: "t-para"
  }, [_vm._v("Teeth only fair")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "top_left"
  }, [_c('p', {
    staticClass: "t-para"
  }, [_vm._v("Good general size")])]), _vm._v(" "), _c('td', {
    staticClass: "top_left"
  }, [_c('p', {
    staticClass: "t-para"
  }, [_vm._v("Pale complexion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "top_left"
  }, [_c('p', {
    staticClass: "t-para"
  }, [_vm._v("Good features")])]), _vm._v(" "), _c('td', {
    staticClass: "top_left"
  }, [_c('p', {
    staticClass: "t-para"
  }, [_vm._v("Only fair figure")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "top_left"
  }, [_c('p', {
    staticClass: "t-para"
  })]), _vm._v(" "), _c('td', {
    staticClass: "top_left"
  }, [_c('p', {
    staticClass: "t-para"
  }, [_vm._v("Large hands and feet")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-b"
  }, [_vm._v("Now you see of the bad points only the last cannot be remedied. Now while slimness is a fashion you can cultivate it by exercise—Find out now from some girl. Exercise would give you a healthier skin. You should never rub cold cream into your face because you have a slight tendency to grow hairs on it. I’d find out about this from some Dr. who’d tell you what you could use in place of a skin cream.")]), _vm._v(" "), _c('p', {
    staticClass: "li-para"
  }, [_c('span', {
    staticClass: "li-num"
  }, [_vm._v("(D) ")]), _vm._v("A girl should always be careful about such things as underskirt showing, long drawers showing under stocking, bad breath, mussy eyebrows (with such splendid eyebrows as yours you should brush them or wet them and train them every morning and night as I advised you to do long ago. They oughtn’t to have a hair out of place.")]), _vm._v(" "), _c('p', {
    staticClass: "li-para"
  }, [_c('span', {
    staticClass: "li-num"
  }, [_vm._v("(E) ")]), _vm._v("Walk and general physical grace. The point about this is that you’ll be up against situations when ever you go out which will call for "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _vm._v("you to be graceful—not to be physically clumsy. Now you can only attain this by practise because it no more comes naturally to you than it does to me. Take some stylish walk you like and imitate it. A girl should have a little class. Look what a stylish walk Eleanor and Grace and Betty have and what a homely walk Marie and Alice have. Just because the first three deliberately practised every where until now its so natural to them that they can’t be ungraceful—This is true about every gesture. I noticed last Saturday that your gestures are awkward and so unnatural as to seem affected. Notice the way graceful girls hold their hands and feet. How they stoop, wave, run and then try because you can’t practise those things when men are around. It’s two late then. They ought to be incentive then.")]), _vm._v(" "), _c('p', {
    staticClass: "li-para"
  }, [_c('span', {
    staticClass: "li-num"
  }, [_vm._v("(F) ")]), _vm._v("General summing up.")]), _vm._v(" "), _c('p', {
    staticClass: "li-para1"
  }, [_c('span', {
    staticClass: "li-num1"
  }, [_vm._v("(1) ")]), _vm._v("dress scrupulously nearly and then forget your personal appearance. Every stocking should be pulled up to the last wrinkle.")]), _vm._v(" "), _c('p', {
    staticClass: "li-para1"
  }, [_c('span', {
    staticClass: "li-num1"
  }, [_vm._v("(2) ")]), _vm._v("Don’t wear things like that fussy hat that aren’t becoming to you—At least buy no more. Take someone who knows with you—some one who really knows.")]), _vm._v(" "), _c('p', {
    staticClass: "li-para1"
  }, [_c('span', {
    staticClass: "li-num1"
  }, [_vm._v("(3) ")]), _vm._v("Conform to your type no matter what looks well in the store")]), _vm._v(" "), _c('p', {
    staticClass: "li-para1"
  }, [_c('span', {
    staticClass: "li-num1"
  }, [_vm._v("(4) ")]), _vm._v("Cultivate deliberate physical grace. You’ll never have it if you don’t. I’ll discuss dancing in a latter letter."), _c('a', {
    attrs: {
      "href": "#/xhtml/18_Chapter6#star_8",
      "id": "star8"
    }
  }, [_vm._v("*")]), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-41",
      "id": "pt3_41",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("41")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-t"
  }, [_vm._v("Fitzgerald’s remote relationship with his sister can be seen in the comment of the hero of “The Romantic Egotist” on his younger brother: “I was intensely critical about him and tried desperately to keep him from falling into a severe self-complacency. I succeeded only too well and finally forced him into a state of self-defence where he leaned almost wholly on mother. All through the next ten years, close as we were thrown together, we never really understood each other.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-42",
      "id": "pt3_42",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In March 1916 Ginevra was dismissed from Westover. Fitzgerald regarded it as a calamity and later incongruously paired it with his wife’s insanity in one of his admonishing letters to his daughter when she was at school: “It was in the cards that Ginevra King should get fired from Westover—also that your mother should wear out young.”"), _c('span', {
    attrs: {
      "href": "#/xhtml/85_Notes#pt3-43",
      "id": "pt3_43",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("43")])]), _vm._v(" He visited Ginevra at Lake Forest in August 1916, but the meeting was unsatisfactory. Fitzgerald was no "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _vm._v(" longer her number-one suitor, and the competition included sons of wealth. It was pointedly remarked in Fitzgerald’s hearing that poor boys shouldn’t think of marrying rich girls.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfn"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/18_Chapter6#star8",
      "id": "star_8"
    }
  }, [_vm._v("*")]), _vm._v(" Fitzgerald later noted on this ten-page document: “Written by me at 19 or so Basis of Bernice.” But Annabel would have been about fourteen then, and his instructions seem to apply to an older girl. In “Bernice Bobs Her Hair,” written in 1919, the heroine is given popularity lessons.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af12ce82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/18_Chapter6.vue
// module id = 111
// module chunks = 0